import { Component, OnInit } from '@angular/core';
import { SupportedBrowsersService } from './supported-browsers.service';

@Component({
  selector: 'sc-supported-browsers-modal',
  templateUrl: './supported-browsers-modal.component.html',
  styleUrls: ['./supported-browsers-modal.component.scss']
})
export class SupportedBrowsersModalComponent implements OnInit {

  shouldDisplay = false;

  constructor(private supportedBrowsersService: SupportedBrowsersService) { }

  ngOnInit() {
    this.shouldDisplay = this.supportedBrowsersService.shouldDisplayModal();
  }

  openChromeDownloadPage() {
    this.supportedBrowsersService.openChromeDownloadPage();
  }

  continue() {
    this.supportedBrowsersService.setModalHaveBeenShown();
    this.shouldDisplay = false;
  }

}
